export const PERMIS_LESSONS_PT = [
  {
    id: 'permis-1',
    numero: 1,
    titre: "Os procedimentos administrativos da carta de condução",
    sousTitre: "ANTS — tudo online",
    contexte: "Carta de condução, renovação, comunicar perda — tudo se faz agora online em ANTS.",
    explication: [
      "**ANTS** (Agência Nacional de Documentos de Viagem e Identidade): permisdeconduire.ants.gouv.fr — site oficial para todos os procedimentos da carta.",
      "**Criar conta em ANTS**: com o número do documento de identidade. Fará os pedidos e acompanhamento a partir daqui.",
      "**Em caso de perda ou roubo**: peça uma carta substituta em ANTS directamente — 25€. Sem necessidade de se deslocar.",
      "**Validade**: a carta de condução europeia é válida 15 anos para condutores com menos de 60 anos. Renovada em ANTS.",
      "**Procuração electrónica**: se não conseguir usar a internet, uma pessoa de confiança pode fazer o pedido em seu nome via ANTS.",
    ],
    question: "Onde fazer o pedido de carta de condução substituta em caso de perda?",
    options: [
      { id: 'a', text: "Em permisdeconduire.ants.gouv.fr", correct: true },
      { id: 'b', text: "Na esquadra de polícia", correct: false },
      { id: 'c', text: "Nos Correios", correct: false },
    ],
    explication_reponse: "Todos os procedimentos da carta de condução fazem-se agora em ANTS. Sem necessidade de se deslocar. O pedido é tratado em 2-3 semanas.",
  },
  {
    id: 'permis-2',
    numero: 2,
    titre: "Os pontos da carta e a sua perda",
    sousTitre: "Compreender o sistema de pontos",
    contexte: "A carta de condução francesa funciona com um sistema de pontos. Como funciona e como recuperar os pontos?",
    explication: [
      "**12 pontos no início**: cada condutor começa com 12 pontos (6 para condutores novatos). Os pontos são retirados por infracções.",
      "**Recuperação de pontos**: após 2 anos sem infracção, recupera automaticamente 2 pontos. Após 3 anos sem qualquer infracção, os pontos voltam ao total.",
      "**Formação voluntária**: pode participar num dia de sensibilização (journée de sensibilisation) para recuperar 4 pontos — uma vez de 2 em 2 anos.",
      "**Verificar os pontos**: em telepoints.ants.gouv.fr ou pedindo um documento relevé d'information em ANTS.",
      "**Carta a zeros**: se os pontos chegarem a zero, a carta é retirada. É necessário refazer o exame após 6 meses.",
    ],
    question: "Como recuperar pontos na carta de condução sem esperar?",
    options: [
      { id: 'a', text: "Participando num dia de sensibilização homologado para recuperar 4 pontos", correct: true },
      { id: 'b', text: "Pagando uma taxa especial à administração de trânsito", correct: false },
      { id: 'c', text: "Não é possível recuperar pontos antes de 5 anos", correct: false },
    ],
    explication_reponse: "O dia de sensibilização (stage de récupération de points) custa cerca de 250€ e recupera 4 pontos. Pode ser repetido de 2 em 2 anos.",
  },
  {
    id: 'permis-3',
    numero: 3,
    titre: "Converter a carta de condução estrangeira",
    sousTitre: "Para quem vem de fora de França",
    contexte: "Chegou a França com uma carta de condução estrangeira. Pode conduzir? Como convertê-la?",
    explication: [
      "**Cartas da União Europeia**: válidas directamente em França — não é necessária conversão. Renovadas quando expiram em ANTS.",
      "**Cartas de países com acordo**: Portugal, Marrocos, Argélia, Tunísia e outros — podem ser convertidas directamente sem refazer o exame.",
      "**Prazo após residência**: tem 1 ano após obter a autorização de residência para converter a carta estrangeira.",
      "**Pedido de conversão**: em ANTS com os seguintes documentos: carta original + tradução certificada, documento de residência, fotografia.",
      "**Cartas sem acordo**: se o país não tiver acordo, é necessário fazer o exame de condução francês completo.",
    ],
    question: "A carta de condução portuguesa é válida directamente em França?",
    options: [
      { id: 'a', text: "Sim, as cartas da UE são válidas directamente", correct: true },
      { id: 'b', text: "Não, é necessário fazer o exame francês", correct: false },
      { id: 'c', text: "Sim mas apenas por 6 meses", correct: false },
    ],
    explication_reponse: "A carta de condução portuguesa, como carta da UE, é válida directamente em França sem qualquer conversão. Quando expirar, renova-a em ANTS.",
  },
  {
    id: 'permis-4',
    numero: 4,
    titre: "A carta profissional e especial",
    sousTitre: "Tipos de cartas em França",
    contexte: "Precisa de uma carta especial para o trabalho? Qual a diferença entre os vários tipos?",
    explication: [
      "**Carta B**: a carta normal para automóveis — o que a maioria das pessoas conhece.",
      "**Carta BE**: para conduzir automóvel com reboque pesado. Complemento da carta B.",
      "**Carta C e CE**: para camiões pesados. Necessária para a profissão de motorista profissional.",
      "**Carta D**: para autocarros de transporte de passageiros. Necessária para motorista profissional.",
      "**Financiar a carta com CPF**: pode usar o saldo CPF para financiar a carta B ou qualquer carta profissional — excelente oportunidade.",
    ],
    question: "Qual a carta necessária para conduzir um camião pesado profissionalmente?",
    options: [
      { id: 'a', text: "Carta C ou CE", correct: true },
      { id: 'b', text: "Carta B com autorização especial", correct: false },
      { id: 'c', text: "Carta D", correct: false },
    ],
    explication_reponse: "Carta C para camiões pesados sem reboque, CE com reboque. A carta D é para autocarros de passageiros. Estas cartas profissionais podem ser financiadas pelo CPF.",
  },
];
